/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { widgetsCreate } from "../funcs/widgetsCreate.js";
import { widgetsDelete } from "../funcs/widgetsDelete.js";
import { widgetsDuplicate } from "../funcs/widgetsDuplicate.js";
import { widgetsGet } from "../funcs/widgetsGet.js";
import { widgetsList } from "../funcs/widgetsList.js";
import { widgetsUpdate } from "../funcs/widgetsUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListWidgetsResult } from "../models/components/listwidgetsresult.js";
import { Widget } from "../models/components/widget.js";
import {
  CreateWidgetRequest,
  CreateWidgetSecurity,
} from "../models/operations/createwidget.js";
import {
  DeleteWidgetRequest,
  DeleteWidgetSecurity,
} from "../models/operations/deletewidget.js";
import {
  DuplicateWidgetRequest,
  DuplicateWidgetSecurity,
} from "../models/operations/duplicatewidget.js";
import {
  GetWidgetRequest,
  GetWidgetSecurity,
} from "../models/operations/getwidget.js";
import {
  ListWidgetsRequest,
  ListWidgetsSecurity,
} from "../models/operations/listwidgets.js";
import {
  UpdateWidgetRequest,
  UpdateWidgetSecurity,
} from "../models/operations/updatewidget.js";
import { unwrapAsync } from "../types/fp.js";

export class Widgets extends ClientSDK {
  /**
   * createWidget widgets
   *
   * @remarks
   * Save a widget. Any member of the project can. The question is validated against the catalog, and the chart against the question, before it is stored.
   */
  async create(
    request: CreateWidgetRequest,
    security?: CreateWidgetSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Widget> {
    return unwrapAsync(widgetsCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteWidget widgets
   *
   * @remarks
   * Delete a widget. Its creator can; deleting someone else's needs project write access.
   */
  async delete(
    request: DeleteWidgetRequest,
    security?: DeleteWidgetSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(widgetsDelete(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * duplicateWidget widgets
   *
   * @remarks
   * Copy a widget into a new one the caller owns, named "<name> (copy)". This is how a widget is shared: a teammate duplicates it rather than editing it. Like every save, the copy is validated, so a broken widget cannot be duplicated until it is fixed.
   */
  async duplicate(
    request: DuplicateWidgetRequest,
    security?: DuplicateWidgetSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Widget> {
    return unwrapAsync(widgetsDuplicate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getWidget widgets
   *
   * @remarks
   * Get one widget by id, validated as it is read.
   */
  async get(
    request: GetWidgetRequest,
    security?: GetWidgetSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Widget> {
    return unwrapAsync(widgetsGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listWidgets widgets
   *
   * @remarks
   * List the project's widgets, most recently updated first. Each is validated as it is read, so a widget a catalog change broke says so.
   */
  async list(
    request?: ListWidgetsRequest | undefined,
    security?: ListWidgetsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListWidgetsResult> {
    return unwrapAsync(widgetsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateWidget widgets
   *
   * @remarks
   * Replace a widget's name, description, dataset, query and visualization. Its creator can; editing someone else's needs project write access.
   */
  async update(
    request: UpdateWidgetRequest,
    security?: UpdateWidgetSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Widget> {
    return unwrapAsync(widgetsUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
